import { combineReducers } from "redux";
import { _FAILURE, _SUCCESS, FETCH_CO_OPERATIONS_OLD_REQUEST } from "./constants";

function items(state = [], action) {
  switch (action.type) {
    case FETCH_CO_OPERATIONS_OLD_REQUEST + _SUCCESS:
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state = false, action) {
  switch (action.type) {
    case FETCH_CO_OPERATIONS_OLD_REQUEST:
      return true;
    case FETCH_CO_OPERATIONS_OLD_REQUEST + _SUCCESS:
    case FETCH_CO_OPERATIONS_OLD_REQUEST + _FAILURE:
      return false;

    default:
      return state;
  }
}

export const cooperationsOld = combineReducers({ items, isFetching });
